// Build-time config. Real values default in (this is a single-family,
// single-deployment tool, not a distributed product) but every value is
// overridable via .env.local / .env.production without touching code -
// see .env.example.

function env(name: string, fallback: string): string {
  const value = (import.meta.env as Record<string, string | undefined>)[name];
  return value && value.length > 0 ? value : fallback;
}

export const MOCK_MODE = env('VITE_MOCK_DATA', '') === 'true';

// The real device/portal API origin - what the QR payload's "endpoint" must
// be, regardless of how the portal's own fetches get there in dev.
export const DEVICE_API_ORIGIN = env('VITE_API_BASE', 'https://api.sieting.family');

// In dev, requests go through the Vite proxy at /api (see vite.config.ts) to
// dodge browser CORS; in a production build they hit the real API origin.
export const API_BASE = import.meta.env.DEV ? '/api' : DEVICE_API_ORIGIN;

export const COGNITO_REGION = env('VITE_COGNITO_REGION', 'us-east-1');
export const COGNITO_USER_POOL_ID = env('VITE_COGNITO_USER_POOL_ID', 'us-east-1_uFXSNS7Gi');
export const COGNITO_CLIENT_ID = env('VITE_COGNITO_CLIENT_ID', '54il2h4r5mvn8aiu8pb7uoolgi');

// Hosted UI domain (no https://, no trailing slash) - set by the hosting
// Terraform's portal_cognito_domain output. A custom domain like this one
// IS the full hosted-UI host already, unlike the old
// *.auth.us-east-1.amazoncognito.com prefixed domain it replaced.
export const COGNITO_DOMAIN = env('VITE_COGNITO_DOMAIN', 'login.sieting.family');

export const OAUTH_SCOPES = 'openid email profile';

// CARTO basemap key. No default on purpose: it's the one value here that
// isn't checked in, so it's injected at build time from the
// PORTAL_CARTO_SECRET_ID GitHub Actions secret (see src/lib/basemap.ts for
// why a key in a static bundle isn't a secret). Empty in a local build - the
// map still renders, just watermarked.
export const CARTO_API_KEY = env('VITE_CARTO_API_KEY', '');

function currentOrigin(): string {
  return window.location.origin;
}

export const REDIRECT_URI = `${currentOrigin()}/callback`;
export const LOGOUT_REDIRECT_URI = `${currentOrigin()}/`;

export const MARKER_STALE_YELLOW_MINUTES = 20;
export const MARKER_STALE_RED_MINUTES = 60;

export const OVERVIEW_REFRESH_MS = 60_000;
